export const environment = {
  production: true,

  excel_upload_saas: "?sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D",
  refresh_token_url:"https://uapi.fof-fuso.com/tokenrefresh/redirect/logbase",
  rackUpload_saas: 'https://a9nprodjpeastlbs01.blob.core.windows.net/pfep-upload-format/RackUploadFormat.zip?sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D',

  noubaUpload_saas: 'https://a9nprodjpeastlbs01.blob.core.windows.net/pfep-upload-format/NoubaUploadFormat.zip?sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D',

  loginUrl_SSO:"https://redirect.fof-fuso.com/lbapp",
  logoutUrl_SSO:"https://login.microsoftonline.com/505cca53-5750-4134-9501-8d52d5df3cd1/oauth2/v2.0/logout",

  approved_packages_saas: "sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D",

  all_parts_data : "sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D",

  package_template_url: 'https://a9nprodjpeastlbs01.blob.core.windows.net/templates/Package_Upload_Template.zip?sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D',

  part_level_master : "sv=2026-02-06&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2036-09-17T17:27:10Z&st=2026-09-17T09:12:10Z&spr=https&sig=sz%2BK2UnZg4D6INGI6GSb5PPSwmEa4wrEkOIsAVLzPFQ%3D"


};

